import { useMemo } from 'react';
import { useProductCatalog } from './useProductCatalog';

/**
 * Returns products for comparison from the local catalog cache.
 * No API call — filters matching IDs from the cached catalog.
 */
export function useCompareProducts(ids: string[]) {
  const { data: catalog, isLoading } = useProductCatalog();

  const products = useMemo(() => {
    if (!catalog || ids.length === 0) return [];
    const numericIds = new Set(ids.map(Number));
    return catalog.filter((p) => numericIds.has(p.id));
  }, [catalog, ids]);

  return { products, isLoading };
}
